import { useState, useEffect } from 'react';
import { getAllDocs } from 'repositories/firebase';
import { COLLECTIONS } from 'constant';
import { IUser } from 'types';

export function useUsers() {
  const [users, setUsers] = useState<IUser[]>([]);
  const [userloading, setUserLoading] = useState<boolean>(true);
  const [userError, setError] = useState<string | null>(null);

  const fetchUsers = async () => {
    try {
      setUserLoading(true);
      const data = await getAllDocs<IUser>(COLLECTIONS.USER);
      setUsers(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch data');
    } finally {
      setUserLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return { users, userloading, userError, fetchUsers };
}
